<template>
  <v-layout row>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="error = 0">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :color="color"
        :top="y === 'top'"
      >
        {{ msg }}
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-flex xs10>
      <h3 class="headline">Billing Information</h3>
      <p class="text-white">
        Client Name: {{ client.name }}
        <br />
        {{ billing_address ? billing_address.division.english_title : "" }} ,
        {{ billing_address ? billing_address.district.english_title : "" }} ,
        {{ billing_address ? billing_address.upazila.english_title : "" }} ,
        {{ billing_address ? billing_address.address : "" }}
      </p>
    </v-flex>
    <v-flex xs2 class="d-flex justify-end">
      <v-btn
        outline
        small
        fab
        color="indigo"
        style="max-width: 41px"
        @click="dialog = true"
      >
        <v-icon>edit</v-icon>
      </v-btn>
    </v-flex>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template> -->
      <v-card>
        <v-card-title class="blue darken-1">
          <span class="headline">Edit Address</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="client.address"
                  label="Enter Your Address*"
                  required
                  box
                ></v-text-field>
              </v-flex> -->
              <v-layout>
                <v-flex sm6 class="mr-2">
                  <v-autocomplete
                    v-model="billingDivision"
                    :items="divDistUpz.divisions"
                    :loading="!divDistUpz"
                    item-text="english_title"
                    item-value="id"
                    :rules="[(v) => !!v || 'Division is required']"
                    label="Division *"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm6 class="ml-2">
                  <v-autocomplete
                    v-model="billingDistrict"
                    :items="getDistrictList(billingDivision)"
                    :loading="!divDistUpz"
                    item-text="english_title"
                    item-value="id"
                    :rules="[(v) => !!v || 'District is required']"
                    label="District *"
                    required
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex sm6 class="mr-2">
                  <v-autocomplete
                    v-model="billingUpazila"
                    :items="getUpazilaList(billingDistrict)"
                    :loading="!divDistUpz"
                    item-text="english_title"
                    item-value="id"
                    :rules="[(v) => !!v || 'Upazila is required']"
                    label="Upazila *"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm6 class="ml-2">
                  <v-text-field
                    v-model="billingPostCode"
                    :rules="[(v) => !!v || 'Post Code is required']"
                    label="Post Code*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-text-field
                v-model="billingAddress"
                :rules="[(v) => !!v || 'Address is required']"
                label="Address*"
                required
              ></v-text-field>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="dialog = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="storeOrUpdate">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import api from "../api/datadash";
import { ROOT_URL } from "@/api/connectingUrls";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data: () => ({
    error: 0,
    errorMsg: "",
    snackbar: false,
    color: "success",
    msg: "Updated successfully",
    y: "top",
    x: "right",
    timeout: 3000,
    dialog: false,
    client: {
      client_id: "",
      name: "",
      address: "",
    },
    divDistUpz: "",
    billing_address: "",

    division: null,
    district: null,
    upazila: "",
    postCode: "",
    billingAddress: null,
    billingDivision: null,
    billingDistrict: null,
    billingUpazila: "",
    billingPostCode: "",
  }),

  computed: {
    ...mapState(["auth"]),
  },
  async mounted() {
    await this.getDivDistUpz();
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          return axios
            .get(`${ROOT_URL}/${"get-address"}`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              if (response.data.statusCode == 200) {
                this.client.client_id = response.data.data.datas.id;
                this.client.name = response.data.data.datas.name || "test name";
                this.client.address = response.data.data.datas.address;
                this.billing_address = response.data.data.datas.billing_address;
                this.billingDivision =
                  response.data.data.datas.billing_address.division_id;
                this.billingDistrict =
                  response.data.data.datas.billing_address.district_id;
                this.billingUpazila =
                  response.data.data.datas.billing_address.upazila_id;
                this.billingAddress =
                  response.data.data.datas.billing_address.address;
                this.billingPostCode =
                  response.data.data.datas.billing_address.post_code;
                this.$emit("update", this.client);
              }
            });
        }
      } catch (error) {
        // console.log(error);
      }
    },
    async storeOrUpdate() {
      this.loading = true;
      try {
        const { data } = await api.storeData(
          this.auth.token,
          "billing-address",
          {
              division_id: this.billingDivision,
              district_id: this.billingDistrict,
              upazila_id: this.billingUpazila,
              post_code: this.billingPostCode,
              address: this.billingAddress,
          }
        );

        if (data.error) {
          this.color = "error";
          this.msg = "Profile Information Update failed";
        } else {
          this.initialize();
          this.color = "success";
          this.msg = "Profile Information Updated successfully";
        }

        this.snackbar = true;
        this.loading = false;
        this.close();
      } catch (e) {
        // console.log(e);
      }
    },
    async getDivDistUpz() {
      try {
        const { data } = await api.fetchData(this.auth.token, "div-dist-upz");
        if (!data.error) {
          this.divDistUpz = data.data;
        }
      } catch (e) {
        //
      }
    },
    getDistrictList(divisionId) {
      return this.divDistUpz.districts
        ? this.divDistUpz.districts.filter(
            (district) => district.division_id == divisionId
          )
        : [];
    },
    getUpazilaList(districtId) {
      return this.divDistUpz.upazilas
        ? this.divDistUpz.upazilas.filter(
            (upazila) => upazila.district_id == districtId
          )
        : [];
    },

    close() {
      this.dialog = false;
      this.$emit("update", this.billingAddress);
      setTimeout(() => {}, 300);
    },
  },
};
</script>
